import { colors } from "@material-ui/core";

import { toast } from "@/design-system/components/Toast/Toast";

import { makeRequest } from "@/util";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { GoogleAdsIcon } from "@/components/icons/themes/logos";
import { Button } from "@/design-system/components/Button/Button";
import { IdentityMatchingRow } from "../shared/IdentityMatchingRow/IdentityMatchingRow";

const CustomerIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  // NB: hacky hyphen stripping occurs in ConfigureIntegrationModal.jsx
  return (
    <ConfigureDestinationsModal
      limitSettings={["customerId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const CustomerIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "customerId" in settings;

  return (
    <DestinationConfigRow
      name="Customer ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthModal = () => {
  return null;
};

const OAuthRow = ({ existingConfig }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const disableRow = !existingConfig.id;

  // Note that this supplants a config
  const onConnectClick = () => {
    makeRequest("get_oauth_url", {
      integration_name: "google-ads-audiences",
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup Google Ads Audiences.",
        );
      });
  };

  // Per Google's branding requirements, to be approved as an app both the text
  // and the icon must appear. We don't need to get _this_ app reapproved as
  // we're reusing the same developer token we use with our normal ads
  // integration, but we still should probably make sure nto to break this rule!
  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#4285F4]"
      leadingIcon={!oauthConfigured && <GoogleAdsIcon className="h-4 w-4" />}
      onClick={onConnectClick}
    >
      {oauthConfigured ? "Reconnect" : "Connect with Google Ads"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      disabled={disableRow}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      // Note that "onOpenConfigModal" is hooked here for OAuth destinations
      // that use a custom config modal for service accounts. Right now, service
      // account support isn't set up for Google Ads Audiences, so this just
      // immediately redirects to the OAuth endpoint
      onOpenConfigModal={onConnectClick}
    />
  );
};

const CUSTOMER_ID = "CUSTOMER_ID";
const OAUTH = "OAUTH";
const IDENTITY_MATCHING = "IDENTITY_MATCHING";

const Rows = {
  [CUSTOMER_ID]: CustomerIDRow,
  [OAUTH]: OAuthRow,
  [IDENTITY_MATCHING]: IdentityMatchingRow,
};

const Modals = {
  [CUSTOMER_ID]: CustomerIDModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [CUSTOMER_ID, OAUTH, IDENTITY_MATCHING];

const config = {
  Rows,
  RowOrder,
  Modals,
};
export default config;
